const SAVE_AFDELING_FILTER = 'SAVE_AFDELING_FILTER';
const SET_BEDRIJF_AFDELING_FILTER = 'SET_BEDRIJF_AFDELING_FILTER';
const RESET_AFDELING_FILTER = 'RESET_AFDELING_FILTER';

const initialState = () => ({
    afdelingFilter: {
        bedrijf: 0,
        zoekstring: '',
    },
});

const module = {
    state: initialState(),
    mutations: {
        [SET_BEDRIJF_AFDELING_FILTER] (state, payload) {
            state.afdelingFilter.bedrijf = payload;
            state.afdelingFilter.zoekstring = '';
        },
        [SAVE_AFDELING_FILTER] (state, payload) {
            state.afdelingFilter = payload;
        },
        [RESET_AFDELING_FILTER] (s) {
            const initial = initialState();
            Object.keys(initial).forEach((key) => { s[key] = initial[key]; });
        },
    },
    actions: {
        setBedrijfAfdelingFilter ({ commit }, payload) {
            commit(SET_BEDRIJF_AFDELING_FILTER, payload);
        },
        saveAfdelingFilter ({ commit }, payload) {
            commit(SAVE_AFDELING_FILTER, payload);
        },
        resetAfdelingFilter ({ commit }, payload) {
            commit(RESET_AFDELING_FILTER, payload);
        },
    },
    getters: {
        afdelingFilter: state => state.afdelingFilter,
    },
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/afdeling.js